export default "__VITE_PUBLIC_ASSET__0f201a6e__"